export interface OdataResponse {
    "@odata.context": string;
    "@odata.count": number;
    value: any;
}